import type {
  FavoriteProblemTree as FavoriteProblemTreeData,
  FavoriteTreeProblem,
} from '@mathflat/domain/FavoriteProblem'
import { makeObservable, observable } from 'mobx'

import { DTO } from '../DTO'

export type FavoriteProblem = FavoriteTreeProblem

export class FavoriteProblemTree extends DTO {
  curriculumId: FavoriteProblemTreeData['curriculumId']
  curriculumName: FavoriteProblemTreeData['curriculumName']
  schoolType: FavoriteProblemTreeData['schoolType']
  revision: FavoriteProblemTreeData['revision']
  relationList: FavoriteProblemTreeData['relationList'] = []

  constructor(data: FavoriteProblemTreeData) {
    super()
    this.curriculumId = data.curriculumId
    this.curriculumName = data.curriculumName
    this.relationList = data.relationList
    this.schoolType = data.schoolType
    this.revision = data.revision

    makeObservable(this, {
      curriculumId: observable,
      curriculumName: observable,
      relationList: observable,
      schoolType: observable,
      revision: observable,
    })
  }
}
